__webpack_require__.p = "/standalone-integrations/referrals-hub/";